import styled, { keyframes } from 'styles/styled';
import chartImg from '../../../assets/Chart.png';
import bullMobile from '../../../assets/PageDetail/bull_mobile.png';
import bearMobile from '../../../assets/PageDetail/bear_mobile.png';

export const GradientSection = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding: 32px 24px;
  background: linear-gradient(180deg, #15191E 0%, #000000 15%, #000000 33%, #15191E 100%);
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;

  @media (max-width: 720px) {
    padding: 24px 16px;
    border-radius: 0 16px 16px 16px;
    gap: 16px;
  }
`;

export const HeroImage = styled.div`
  width: 100%;
  max-width: 400px;
  height: 180px;
  position: relative;
  background-image: url(${chartImg});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 45%;
    height: 100%;
    background-image: url(${bullMobile});
    background-size: contain;
    background-position: left bottom;
    background-repeat: no-repeat;
  }

  &::after {
    content: '';
    position: absolute;
    right: 0;
    bottom: 0;
    width: 38%;
    height: 85%;
    background-image: url(${bearMobile});
    background-size: contain;
    background-position: right bottom;
    background-repeat: no-repeat;
  }

  @media (max-width: 720px) {
    height: 140px;
    max-width: 320px;
  }
`;

export const Headline = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: #FFFFFF;
  margin: 0;
  text-align: center;

  @media (max-width: 720px) {
    font-size: 20px;
  }
`;

export const Subtitle = styled.p`
  font-size: 14px;
  color: #EFEFEF;
  font-weight: 300;
  margin: 0;
  text-align: center;
`;

export const TournamentTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: #52D381;
  margin: 8px 0 0;
  text-align: center;

  @media (max-width: 720px) {
    font-size: 16px;
  }
`;

export const TournamentTitleLabel = styled.span`
  color: #EFEFEF;
  margin-right: 4px;
`;

export const CountdownBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #343434;
  padding: 8px 32px;
  border-radius: 24px;

  @media (max-width: 720px) {
    padding: 6px 24px;
  }
`;

export const CountdownBarLabel = styled.span`
  font-size: 14px;
  color: #EFEFEF;
  font-weight: 300;
  line-height: 1;

  @media (max-width: 720px) {
    font-size: 12px;
  }
`;

export const CountdownBarValue = styled.span`
  font-size: 22px;
  color: #EFEFEF;
  font-weight: 500;
  line-height: 1;

  @media (max-width: 720px) {
    font-size: 18px;
  }
`;

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

export const CountdownSpinner = styled.div`
  width: 24px;
  height: 24px;
  border: 3px solid rgba(239, 239, 239, 0.25);
  border-top-color: #52D381;
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`;

export const DetailsTable = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  max-width: 360px;
  margin: 8px auto 0;
`;

export const DetailRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: baseline;
  gap: 8px;
`;

export const DetailLabel = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: #EFEFEF;
  white-space: nowrap;
`;

export const DetailValue = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: #52D381;
`;
